<template>
  <div class="box">
    <img class="bg" src="../../assets/img/welcome@2x.png" alt="bg">
    <div class="footer">
      <div class="download" @click="download">点击下载</div>
    </div>
    <div class="mask" v-show="maskVisible" @click="maskVisible = false">
      <img class="img" src="../../assets/img/5@2x.png" alt="mask" />
    </div>
  </div>
</template>

<script>
import reqwest from 'reqwest';
import {
  isWeixin, isDingtalk, isIOS, getStoreUrl,
} from './utils';

export default {
  data() {
    return {
      maskVisible: false,
    };
  },
  methods: {
    download() {
      console.log({ isWeixin, isIOS, isDingtalk });
      if ((isWeixin && !isIOS) || isDingtalk) {
        this.maskVisible = true;
        return;
      }
      const url = getStoreUrl();
      console.log('url:', url);
      if (url) {
        window.location.href = url;
        return;
      }
      reqwest({
        url: '/customer-app/api/sys/checkVersion',
        contentType: 'application/json',
        type: 'json',
        method: 'get',
        headers: {
          AppType: 'Android',
          AppVersion: '1.0.0',
        },
      })
        .then((res) => {
          if (res.code !== 0) {
            alert(res.msg);
            return;
          }
          const { downloadLink } = res.data;
          console.log(res.data);
          const iframe = document.createElement('iframe');
          iframe.style.display = 'none';
          iframe.src = downloadLink;
          document.documentElement.appendChild(iframe);
          setTimeout(() => {
            document.documentElement.removeChild(iframe);
          }, 1000);
        })
        .catch((err) => {
          alert('网络错误');
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  position: relative;
  .bg {
    display: block;
    width: 100%;
  }
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding-bottom: 2rem;

  .download {
    margin: 3rem auto 0;
    width: 14rem;
    height: 2.2rem;
    line-height: 2.2rem;
    background-color: #367FEE;
    font-size: .9rem;
    color: #fff;
    text-align: center;
    border-radius: .3rem;
  }
}

.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(47, 47, 47, .7);

  .img {
    display: block;
    width: 14.1rem;
    height: 13.55rem;
    margin-top: .35rem;
    margin-left: 3.4rem;
  }
}
</style>
